'use strict';

import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
var _require = require('../../../api'),
  getRawDataApi = _require.getRawDataApi;

/**
 * 區間硬上限（天）。後端也擋一次 —— 這裡擋是為了不用等一趟往返就給回饋。
 *
 * 資料量的上限在**後端**（伺服器記憶體），不在這裡 —— 欄位數要看過資料才知道，
 * 前端估不準。超過會回 400 帶訊息，直接顯示給使用者。
 * 見 docs/adr/0007-rawdata-download-cell-budget.md。
 */
var MAX_DAYS = 7;

/** 含頭含尾的天數 */
var daysBetween = function daysBetween(from, to) {
  return Math.round(DateTime.fromISO(to).diff(DateTime.fromISO(from), 'days').days) + 1;
};

/**
 * 下載原始資料 xlsx。後端直接把檔案串回來，這裡只負責存檔。
 * @param {string} factory '鳳山圳滯洪池_f001'
 * @param {string} from 台北日 yyyy-MM-dd（含）
 * @param {string} to 台北日 yyyy-MM-dd（含）
 * @param {string[]} selectedOptions 下載項目
 * @returns {Promise<{ok: boolean, message?: string}>}
 */
var rawDataDownload = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(factory, from, to, selectedOptions) {
    var _result, _result$data;
    var result, _JSON$parse, factoryName, range, url, link;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return getRawDataApi(factory, from, to, selectedOptions);
          case 3:
            result = _context.sent;
            _context.next = 32;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            console.log('rawDataDownload failed', _context.t0);
            // responseType 是 blob，所以錯誤訊息也是 Blob —— 要讀成文字才看得到後端說什麼
            // （資料量過大、目前有人在下載，這些都要讓使用者看到，不能吞成「尚無資料」）
            _context.prev = 9;
            if (!(_context.t0 instanceof Blob)) {
              _context.next = 26;
              break;
            }
            _context.t2 = JSON;
            _context.next = 14;
            return _context.t0.text();
          case 14:
            _context.t3 = _context.sent;
            _context.t4 = _JSON$parse = _context.t2.parse.call(_context.t2, _context.t3);
            _context.t1 = _context.t4 === null;
            if (_context.t1) {
              _context.next = 19;
              break;
            }
            _context.t1 = _JSON$parse === void 0;
          case 19:
            if (!_context.t1) {
              _context.next = 23;
              break;
            }
            _context.t5 = void 0;
            _context.next = 24;
            break;
          case 23:
            _context.t5 = _JSON$parse.msg;
          case 24:
            _context.t6 = _context.t5;
            return _context.abrupt("return", {
              ok: false,
              message: _context.t6
            });
          case 26:
            _context.next = 31;
            break;
          case 28:
            _context.prev = 28;
            _context.t7 = _context["catch"](9);
            console.log('parse error blob failed', _context.t7);
          case 31:
            return _context.abrupt("return", {
              ok: false
            });
          case 32:
            if ((_result = result) !== null && _result !== void 0 && (_result$data = _result.data) !== null && _result$data !== void 0 && _result$data.size) {
              _context.next = 34;
              break;
            }
            return _context.abrupt("return", {
              ok: false
            });
          case 34:
            factoryName = factory.split('_')[0];
            range = from === to ? from : "".concat(from, "_").concat(to);
            url = window.URL.createObjectURL(result.data);
            link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "".concat(factoryName, "_").concat(range, ".xlsx"));
            link.click();
            window.URL.revokeObjectURL(url);
            return _context.abrupt("return", {
              ok: true
            });
          case 43:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6], [9, 28]]);
  }));
  return function rawDataDownload(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
export { rawDataDownload, daysBetween, MAX_DAYS };